import { render } from "./DeleteInformationPart.vue?vue&type=template&id=1bf7166e"
import script from "./DeleteInformationPart.vue?vue&type=script&lang=js"
export * from "./DeleteInformationPart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__